import { useEffect, useRef, useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import i18next from 'i18next';
import { useResultContext } from '../../context/ResultContextProvider';
import { recordSeat } from '../../utils/interestTracker';
import './Search.css';

export const Search = () => {
  const { result, fetchData } = useResultContext();
  const [text, setText] = useState('');
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (text.length === 0) return;
    const id = setTimeout(() => fetchData(`?name=${text}`), 200);
    return () => clearTimeout(id);
  }, [text, fetchData]);

  useEffect(() => {
    const onClick = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const showOptions = open && text.length > 0 && Array.isArray(result) && result.length > 0;

  return (
    <div className="div_search">
      <div className="search-combobox" ref={wrapperRef}>
        <input
          type="text"
          className="search-input"
          placeholder={i18next.t('搜索议席')}
          value={text}
          role="combobox"
          aria-expanded={showOptions}
          aria-autocomplete="list"
          onChange={(e) => {
            setText(e.target.value);
            setOpen(true);
          }}
          onFocus={() => setOpen(true)}
        />
        {text && (
          <button
            type="button"
            className="search-clear"
            aria-label="Clear"
            onClick={() => {
              setText('');
              setOpen(false);
            }}
          >
            ×
          </button>
        )}
        {showOptions && (
          <ul className="search-options" role="listbox">
            {result.map((data) => (
              <li key={data.search} role="option">
                <HashLink
                  to={`/seats/${data.state}/${data.seatNP.toLowerCase()}/#s${data.seatNP}${data.seatno}`}
                  onClick={() => {
                    setOpen(false);
                    recordSeat({
                      slug: data.state,
                      seatname: `${data.seatNP}${data.seatno}`,
                      label: data.cname || data.name,
                    });
                  }}
                  className="search-option"
                >
                  {data.seatNP + data.seatno + ' ' + data.name + ' ' + data.cname}
                </HashLink>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};
